<template>
    <span v-html="text"></span>
</template>
<script setup lang="ts">
import { $tm } from '@/locize';
import { ref } from 'vue';

/**
 * This shows the raw text without any translation or anything
 */
const props = defineProps<{
    /**
     * The text to display
     */
    value: string | null;
}>();

const text = ref<string | null>($tm(props.value ?? '', '', true));
</script>
